/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_Dialog_TitleInputs */

const en_cmdk_dialog_title = /** @type {(inputs: Cmdk_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command menu`)
};

const es_cmdk_dialog_title = /** @type {(inputs: Cmdk_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú de comandos`)
};

/**
* | output |
* | --- |
* | "Command menu" |
*
* @param {Cmdk_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_dialog_title = /** @type {((inputs?: Cmdk_Dialog_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_Dialog_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_dialog_title(inputs)
	return en_cmdk_dialog_title(inputs)
});